import { forwardRef, useEffect } from "react";

import { cn } from "../../utils/cn";
import { useDrawerContext } from "./context";

import type { HTMLAttributes, ReactNode } from "react";

export interface DrawerHeaderProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export const DrawerHeader = forwardRef<HTMLDivElement, DrawerHeaderProps>(
  ({ children, className, ...props }, ref) => {
    const { slots, classNames, headerId, setHeaderMounted, title } = useDrawerContext();

    useEffect(() => {
      setHeaderMounted(true);
      return () => setHeaderMounted(false);
    }, [setHeaderMounted]);

    return (
      <header
        ref={ref}
        id={headerId}
        className={slots.header({ className: cn(classNames?.header, className) })}
        data-slot="header"
        {...props}
      >
        {title && <div className={slots.title({ className: classNames?.title })}>{title}</div>}
        {children}
      </header>
    );
  }
);
DrawerHeader.displayName = "Drawer.Header";
